import Api from '../Base'

class DeleteSspsaTask extends Api {
  requestUrl = `/api/SspsaTask/${this.getParams().id}`

  method = 'DELETE'
}

export default DeleteSspsaTask
